import numeral from 'numeral';

export function commaFormatted(number) { return numeral(number).format('0,0'); }

export function percentFormatted(number) {
  return numeral(number).format('0.00');
}

export function scientificFormatted(number) {
  const format = (number > 1000000) ? '0.00a' : '0.0a';
  return numeral(number).format(format);
}

export function getGraphLabelFormatting(tooltipItem, data) {
  const label = data.labels[tooltipItem.index];
  const datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  return `${label} - ${commaFormatted(datasetLabel)}`;
}

export function getGraphLabelPercentageFormatting(tooltipItem, data) {
  const label = data.labels[tooltipItem.index];
  const datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  return `${label} - ${commaFormatted(datasetLabel)} %`;
}

export function sciFormatted(number) {
  if (!number) return '-';
  const format = (number > 1000000) ? '0.0a' : '0,0a';
  return numeral(number).format(format);
}

export function sf(num) {
  if (!num) return '-';
  return numeral(num).format('0a');
}



/** WEBPACK FOOTER **
 ** ./src/utils/formatting.js
 **/